import { Reveal } from "./Reveal";
import { Quote } from "lucide-react";

const quotes = [
  {
    text: "Sagos brought order to a financial life that felt overwhelming. For the first time, I understand exactly where I stand and where I'm headed.",
    name: "Eleanor W.",
    detail: "Client since 2018",
  },
  {
    text: "When we sold our business, their guidance on structure and tax saved us more than a decade of fees. Genuinely a partner, not a vendor.",
    name: "James & Rachel T.",
    detail: "Business owners",
  },
  {
    text: "Calm, responsive, and impeccably prepared for every meeting. My advisor knows my family as well as my portfolio.",
    name: "Dr. Anil M.",
    detail: "Client since 2020",
  },
];

export const Testimonials = () => (
  <section className="py-24 md:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="max-w-2xl mb-14">
        <p className="overline text-primary mb-4">In Their Words</p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900 leading-tight">
          Relationships measured in decades.
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-6">
        {quotes.map((q, i) => (
          <Reveal key={q.name} delay={i * 0.1}>
            <figure className="h-full rounded-2xl border border-border bg-white p-8 flex flex-col">
              <Quote className="text-primary/30" size={36} />
              <blockquote className="mt-5 text-slate-700 leading-relaxed flex-1">&ldquo;{q.text}&rdquo;</blockquote>
              <figcaption className="mt-6 pt-6 border-t border-border">
                <p className="font-serif text-lg text-slate-900">{q.name}</p>
                <p className="overline text-slate-400 mt-1">{q.detail}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
